import { useCallback, useEffect, useState } from 'react';
import { loadHomeSummary } from '../services/homeSummary';

export const useHomeSummary = (currencyId, sessionKey) => {
    const scope = `${sessionKey}:${currencyId}`;
    const [revision, setRevision] = useState(0);
    const [state, setState] = useState({ data: null, loading: true, error: null });
    const refresh = useCallback(() => setRevision(value => value + 1), []);
    useEffect(() => {
        const controller = new AbortController();
        let active = true;
        setState({ data: null, loading: true, error: null, scope });
        const timeout = setTimeout(() => controller.abort(), 20000);
        loadHomeSummary({ currencyId, signal: controller.signal })
            .then(data => { if (active) setState({ data, loading: false, error: null, scope }); })
            .catch(error => {
                if (active) setState({ data: null, loading: false, scope, error: error.name === 'AbortError'
                    ? 'La consulta tardó demasiado. Vuelve a intentar.' : error.message });
            })
            .finally(() => clearTimeout(timeout));
        return () => { active = false; clearTimeout(timeout); controller.abort(); };
    }, [currencyId, sessionKey, revision, scope]);
    useEffect(() => {
        const onFocus = () => { if (document.visibilityState === 'visible') refresh(); };
        window.addEventListener('focus', onFocus);
        document.addEventListener('visibilitychange', onFocus);
        return () => {
            window.removeEventListener('focus', onFocus);
            document.removeEventListener('visibilitychange', onFocus);
        };
    }, [refresh]);
    return { data: state.scope === scope ? state.data : null,
        error: state.scope === scope ? state.error : null,
        loading: state.loading || state.scope !== scope, refresh };
};
